import DEFINE from "../painter/define";
import PainterProxy from "../painter/proxy";
import Debugger from '../../js/console/debugger'
import EventBus from "../event_bus";

export default class OtherTool {


    constructor() {

    }

    getToolFunction() {
        return [
            {
                key: "text_tip",
                event: this.useSticky()
            },
            {
                key: "text_box",
                event: this.useTextBox()
            },
            {
                key: "image",
                event: this.useInsertPicture()
            },
            {
                key: "web_link",
                event: this.useInsertWebLink()
            },
            {
                key: "sticker",
                event: this.usePeelableSticker()
            },
            {
                key: "stamp",
                event: this.useStamp()
            },
            //========== JS 傳 Vue ==============
            {
                key: "sendWebLink",
                event: this.sendWebLink()
            },
            {
                key: "sendInsertPicture",
                event: this.sendInsertPicture()
            },
            {
                key: "sendSticky",
                event: this.sendSticky()
            },
            {
                key: "sendTextBoxSelectDirection",
                event: this.sendTextBoxSelectDirection()
            },
            {
                key: "sendTextBoxBar",
                event: this.sendTextBoxBar()
            },
        ]
    }

    useSticky() {
        Debugger.Instance.log("text_tip", "insert_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(DEFINE.TOOLS.STICKY);
        }
    }

    useTextBox() {
        Debugger.Instance.log("text_box", "insert_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(DEFINE.TOOLS.TEXT_BOX);
        }
    }

    useInsertPicture() {
        Debugger.Instance.log("image", "insert_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(DEFINE.TOOLS.INSERT_PICTURE);
        }
    }

    useInsertWebLink() {
        Debugger.Instance.log("web_link", "insert_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(DEFINE.TOOLS.INSERT_WEB_LINK);
        }
    }

    usePeelableSticker() {
        Debugger.Instance.log("sticker", "insert_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(DEFINE.TOOLS.PEELABLE_STICKER);
        }
    }

    useStamp() {
        Debugger.Instance.log("sticker", "insert_tool");
        const proxy = PainterProxy.getInstance();
        let stampBoard = EventBus.getInstance().getAppRefs().stampBoard

        return () => {
            stampBoard.isShow = true;
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(DEFINE.TOOLS.STAMP);
        }
    }

    sendWebLink() {
        const self = this;
        let webLinkGroup = null;
        let callBack = null;
        return (value) => {
            if (PainterProxy.getInstance().currentToolName == DEFINE.TOOLS.STAMP) return;
            let webLink = EventBus.getInstance().getAppRefs().insertWebLink
            switch (value.type) {
                case DEFINE.TAG.INSERT_WEB_LINK_EDIT_PEN:
                    webLinkGroup = value.arg;
                    webLink.setWebLinkData(webLinkGroup, webLinkGroup.data.url, webLinkGroup.data.titleName);
                    webLink.showView(true);
                    break;
                case DEFINE.TAG.INSERT_WEB_LINK_TITLE:
                    console.log(DEFINE.TAG.INSERT_WEB_LINK_TITLE);
                    webLinkGroup = value.arg;
                    callBack = value.callBack;
                    webLink.setWebLinkData(webLinkGroup, webLinkGroup.data.url, webLinkGroup.data.titleName);
                    webLink.openUrl(callBack);
                    break;
            }
        }
    }

    sendInsertPicture() {
        let insertPicture = EventBus.getInstance().getAppRefs().insertPicture
        return (value) => {
            if (PainterProxy.getInstance().currentToolName == DEFINE.TOOLS.STAMP) return;
            insertPicture.setInsertPicture(value.insertPicture);
            insertPicture.setPointer(value.pointer);
            insertPicture.clickFileInputEl();
        }
    }

    sendSticky() {
        const self = this;
        let sticky = EventBus.getInstance().getAppRefs().sticky
        return (value) => {
            if (PainterProxy.getInstance().currentToolName == DEFINE.TOOLS.STAMP) return;
            sticky.updateStickyData(value.sticky, value.title, value.message, value.stickyTool);

            sticky.stickyShow(true);
        }
    }

    sendTextBoxSelectDirection() {
        const self = this;
        let textBox = EventBus.getInstance().getAppRefs().textBox
        return (value) => {
            if (PainterProxy.getInstance().currentToolName == DEFINE.TOOLS.STAMP) return;
            textBox.isDirectionBarShow(true);
            textBox.setDirectionBarPoint(value, value.point.x, value.point.y);
        }
    }

    sendTextBoxBar() {
        const self = this;
        let textBox = EventBus.getInstance().getAppRefs().textBox
        return (value) => {
            if (PainterProxy.getInstance().currentToolName == DEFINE.TOOLS.STAMP) return;
            if (value.arg) textBox.setSelectTextSize(value.arg.textSize);

            textBox.isTextBoxBarShow(value.boxBarShow);

            if (value.boxBarShow == true) {
                textBox.setTextBoxBarPoint(value, value.point.x, value.point.y);
            }
        }
    }
}